import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-chain';

export default {
    path: '/bcos/chain',
    name: '链管理',
    redirect: {
        name: `${pre}group`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'group',
            name: `${pre}group`,
            meta: {
                ...meta,
                title: '节点管理',
                closable: true
            },
            component: () => import('@/bcos/views/group')
        },
    ]
};
